// Angular
import { Component, Input, SimpleChanges, OnChanges, Output, EventEmitter } from "@angular/core";

//libs
import { faCaretDown, IconDefinition, faRecycle } from "@fortawesome/free-solid-svg-icons";

// Afidium
import { WORDING } from "../config/wording";
import { PROCESSING_WORDING } from "libraries/service/processing/processing.service";
import { IProcessing } from "app_sasha/shared/resources/processings/IProcessing";
import { DateService } from "libraries/date/date.service";

@Component({
    selector: 'processing-info',
    template: `
        <card>
            <div class="card-header-content">
                {{types[processing.type]}} : {{getProcessingTitle()}}
                <btn type="actionLink"
                     [label]="wording.refresh"
                     *ngIf="canRefresh"
                     (onClick)="onRefresh.emit()">
                    <fa-icon [icon]="iconRecycle"></fa-icon>
                </btn>
            </div>
            <div class="card-body-content card-marge-inside">
                <div class="sep-bottom col-to-row-s-tb">
                    <strong class="sep-right">{{wording.status}}  </strong>
                    <processing-status-list [status]="processing.status"
                                            [select]="select"
                                            [selectedStatus]="selectedStatus"
                                            (onSelect)="onSelect.emit($event)"></processing-status-list>
                </div>
                <div class="sep-bottom" *ngIf="processing.parameter.modelName">
                    <strong>{{wording.model}} :</strong>
                    <ng-container (click)="showBody = !showBody">
                        {{processing.parameter.modelName}}
                    </ng-container>
                    <btn (click)="showBody = !showBody" type="actionLink">
                        <span class="icon"><fa-icon [icon]="iconCaretDown"></fa-icon></span>
                    </btn>
                    <div *ngIf="showBody" class="sep-left">
                        <div class="sep-bottom">{{processing.parameter.subject}}</div>
                        <div>{{processing.parameter.body}}</div>
                    </div>
                </div>
                <div class="col-to-row-s-tb">
                    <div class="flex-1">
                        <strong>{{wording.whenCreated}} : </strong>
                        {{processing.whenCreated | dateMoment:dateService.dateFormats.momentShort}} -
                        {{processing.whenCreated | dateMoment:dateService.dateFormats.momentTime}}
                    </div>
                    <div *ngIf="processing.whenBegan" class="flex-1">
                        <strong>{{wording.whenBegan}} : </strong>
                        {{processing.whenBegan | dateMoment:dateService.dateFormats.momentShort}} -
                        {{processing.whenBegan | dateMoment:dateService.dateFormats.momentTime}}
                    </div>
                    <div *ngIf="processing.whenEnded" class="flex-1">
                        <strong>{{wording.whenEnded}} : </strong>
                        <span class="e2e-info-hour">
                        {{processing.whenEnded | dateMoment:dateService.dateFormats.momentShort}} -
                        {{processing.whenEnded | dateMoment:dateService.dateFormats.momentTime}}
                        </span>
                    </div>
                </div>
            </div>
        </card>
    `
})
export class ProcessingInfoComponent implements OnChanges {
    @Input()
    public processing: IProcessing;

    @Input()
    public select: boolean;

    @Input()
    public selectedStatus: string;

    @Output()
    public readonly onRefresh: EventEmitter<void> = new EventEmitter();

    @Output()
    public readonly onSelect: EventEmitter<string> = new EventEmitter();

    public types: { [key: string]: string } = PROCESSING_WORDING;
    public wording: { [key: string]: string } = WORDING;

    public showBody: boolean = false;

    public canRefresh: boolean = false;

    public iconCaretDown: IconDefinition = faCaretDown;

    public iconRecycle: IconDefinition = faRecycle;

    constructor(public readonly dateService: DateService) {
    }

    public getProcessingTitle(): string {
        if (this.processing.parameter.subject) {
            return this.processing.parameter.subject;
        }
        return this.processing.title;
    }


    public ngOnChanges(changes: SimpleChanges): void {
        this.canRefresh = Boolean(
            this.processing && (this.processing.status.processing || this.processing.status.pending)
        );
    }

}
